import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetQualityChecksProps {
  projectId: string;
  taskId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityChecks = async (taskId: string, projectId: string) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/quality-checks`);

const useGetQualityChecks = ({
  taskId,
  projectId,
  queryParams,
}: UseGetQualityChecksProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["quality-checks", taskId],
    queryFn: () => getQualityChecks(taskId, projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityChecks;
